import fetch from '../utils/fetch'

// 獲取信任登入列表
export function getTrustLoginList (query) {
  return fetch({
    url: 'members/trustlogin/list',
    method: 'post'
    // params: query
  })
}

// 儲存信任登入狀態
export function saveStatusSetting (query) {
  return fetch({
    url: 'members/trustlogin/setting',
    method: 'put',
    params: query
  })
}
